export default __webpack_public_path__ + "static/media/paperhand.9d9f8120.png";